module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.0.0.box.674.784.422.260.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "156%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.2.0.0.box.674.784.422.260.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _vm._v("Confederate Women")]), _c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.1.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.3.0.0.box.216.2030.1327.431.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.3.0.0.box.216.2030.1327.431.q.60"
    }
  }, [_vm._v("COVER ART: \"A Night on the Battlefiel"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  }), _vm._v("d\" by Oregon Wil"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _vm._v("son. It depicts a tru"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _vm._v("e incident following "), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v("the Battle of Third W"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.2.0"
    }
  }), _vm._v("inchester. On the nig"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _vm._v("ht of September 19, 1"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.5.0.0"
    }
  }), _vm._v("864, a young lady nam"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.5.1.0"
    }
  }), _vm._v("ed Tilly Russell sear"), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.6.0.0"
    }
  }), _vm._v("ched the battlefield "), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.7.0.0"
    }
  }), _vm._v("for wounded. She came"), _c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _vm._v(" across twenty year old Captain Randolph R"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("idgely of General Ramseur's staff, Arm"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _vm._v("y of Northern Virgini"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _vm._v("a. Miss Russell sat a"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.1.0"
    }
  }), _vm._v("ll night, holding the"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _vm._v(" young officer and st"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.1.0"
    }
  }), _vm._v("aunching a bleeding w"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.3.0"
    }
  }), _vm._v("ound, until morning w"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.4.0"
    }
  }), _vm._v("hen help arrived. (Co"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.0.0"
    }
  }), _vm._v("urtesy of Handley Lib"), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0"
    }
  }), _vm._v("rary, Winchester, VA.)")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.217.807.1327.579.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.6.0.0.box.217.807.1327.286.q.60"
    }
  }, [_vm._v("\"To the Women of the Confederacy whose fidelity, whose purity, whose courage, whose gentle genius in love and in counsel, kept home secure, and family a school of virtue, the State a Court of virtue; who made war a season of heroism, and peace a time of healing. The guardians of our tranquility and strength.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "text-align": "right",
      "font-style": "italic",
      "margin-left": "0"
    },
    attrs: {
      "id": "para.6.0.1.box.991.1166.549.220.q.70"
    }
  }, [_vm._v("Woodrow "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wilson ")]), _c('br'), _vm._v("Dedication "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Monument ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _vm._v("the "), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.0.0"
    }
  }), _vm._v("Women ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.2.0"
    }
  }), _vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.4.0"
    }
  }), _vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.6.0"
    }
  }), _vm._v("South ")]), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.7.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.9.0"
    }
  }), _vm._v("Rome, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.11.0"
    }
  }), _vm._v("Georgia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.13.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.15.0"
    }
  }), _vm._v("March ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.16.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.3.19.0"
    }
  }), _vm._v("10, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _vm._v("1910 ")]), _c('br')])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96e7b036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0004.vue
// module id = 54
// module chunks = 0